import BaseModal from 'app/views/modals/base_modal';

import tmpl from 'templates/credit_card_error_modal';

export default BaseModal.extend({
  compiledTemplate: tmpl,

  events: {
    'click .okay': 'close',
  },

  context() {
    return {
      message: this.message || 'There was an issue linking your credit card. Please try again.',
    };
  },
});



// WEBPACK FOOTER //
// ./app/views/modals/credit_card_error_modal.js